import { render } from "./BalanceImg.vue?vue&type=template&id=1f5dc830&scoped=true"
import script from "./BalanceImg.vue?vue&type=script&lang=js"
export * from "./BalanceImg.vue?vue&type=script&lang=js"

import "./BalanceImg.vue?vue&type=style&index=0&id=1f5dc830&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5dc830"]])

export default __exports__